import { CompareVFXConsumer } from './compare-vfx';
import { useSuperstarDetailContext } from './context';
import {
  RosterStarSelect,
  getAvailableStarOptions,
} from '@wwe-portal/ui/features/roster/roster-star-select';
import { useMemo } from 'react';

export const SelectStarConsumer = () => {
  const { selectedStar, selectedStarColor, changeStar } =
    useSuperstarDetailContext((state) => ({
      selectedStar: state.currentStats.selectedStar,
      selectedStarColor: state.currentStats.selectedStarColor,
      changeStar: state.changeStar,
    }));

  const availableStars = useMemo(
    () => getAvailableStarOptions(selectedStarColor),
    [selectedStarColor]
  );

  return (
    <div>
      <div className="mb-1 flex items-center gap-2">
        <span className="drop-shadow-text-2 text-sm font-bold uppercase italic text-[#00BFFF]">
          Select stars
        </span>
      </div>
      <CompareVFXConsumer>
        <RosterStarSelect
          value={selectedStar}
          starColor={selectedStarColor}
          onChange={changeStar}
          availableStars={availableStars}
        />
      </CompareVFXConsumer>
    </div>
  );
};
